<template>
  <page-outline :title="$t('mandate.payment_schedule_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="min-w-100 justify-content-start align-items-center">
          <b-col cols="12" class="d-flex justify-content-start mt-3">
            <back-button class="btnFilter_2 mr-2" :returnUrl="returnUrl"></back-button>
            <b-button class="back-button btnFilter_2" @click="getPaymentSchedule()" >
              <i class="fa-solid fa-rotate-right"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <br></br>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="listItemsPaymentSchedule.length > 0">
          <b-row class="justify-content-center">
            <b-col cols="12" class="mt-3">
              <div>
                <form-accordion :title="$t('mandate.mandate_info')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.unique_mandate_rf')" :inputValue="listItemsPaymentSchedule[0].UMR || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.dbtr')" :inputValue="listItemsPaymentSchedule[0].debtor || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion :title="$t('mandate.cdtr_info')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <component
                        v-if="!editMode"
                        :is="'form-read-group-label-input'"
                        :inputLabel="$t('mandate.cdtr_iban')"
                        :inputValue="(listItemsPaymentSchedule[0].CdtrIBAN) || '-'"
                      />
                      <form-write-group-label-input v-else
                        v-model.trim="listItemsPaymentSchedule[0].CdtrIBAN"
                        :inputLabel="$t('mandate.cdtr_iban')"
                        :placeholderValue="$t('mandate.cdtr_iban')"
                        isMandatory
                        :maxLength="27">
                      </form-write-group-label-input>
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion :title="$t('mandate.payment_schedule_details')" :isTitleUpperCase="false">
                  <b-row class="form-group">
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.status_collection')" :inputValue="$t('mandate.status_payment_schedule_' + listItemsPaymentSchedule[0].status) || '-'">
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <!-- <form-read-group-label-input
                        :inputLabel="$t('mandate.rsn_debit')" :inputValue="listItemsPaymentSchedule[0].reason || '-'">
                      </form-read-group-label-input> -->
                      <component
                        :is="editMode ? 'form-write-group-label-input' : 'form-read-group-label-input'"
                        :inputLabel="$t('mandate.rsn_debit')"
                        v-model="listItemsPaymentSchedule[0].reason"
                        :inputValue="listItemsPaymentSchedule[0].reason || '-'"
                      />
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <component
                        v-if="!editMode"
                        :is="'form-read-group-label-input'"
                        :inputLabel="$t('mandate.frequency_type')"
                        :inputValue="$t('mandate.frequency_type_' + listItemsPaymentSchedule[0].frequency) || '-'"
                      />
                      <div v-else>
                        <label>
                          {{ $t('mandate.frequency_type') }} <span style="color: red">*</span>
                        </label>
                        <select class="form-control" v-model="listItemsPaymentSchedule[0].frequency">
                          <option value="" disabled>{{ $t('mandate.frequency_type_select') }}</option>
                          <option
                            v-for="p in FrequencyTypeList"
                            :key="p.value"
                            :value="p.value"
                          >
                            {{ $t(p.label) }}
                          </option>
                        </select>
                      </div>
                    </b-col>
                    <b-col sm="4" class="mb-5" v-if="listItemsPaymentSchedule[0].frequency === '1' || listItemsPaymentSchedule[0].frequency === 1">
                      <component
                        :is="editMode ? 'form-write-group-label-input' : 'form-read-group-label-input'"
                        :inputLabel="$t('mandate.amt')"
                        v-model="listItemsPaymentSchedule[0].amountR"
                        :inputValue="formatCurrency(listItemsPaymentSchedule[0].amountR) || '-'"
                        :isMandatory="editMode"
                      />
                    </b-col>
                    <b-col sm="4" class="mb-5" v-if="listItemsPaymentSchedule[0].frequency === '1' || listItemsPaymentSchedule[0].frequency === 1">
                      <component
                        v-if="!editMode"
                        :is="'form-read-group-label-input'"
                        :inputLabel="$t('mandate.date_first_debit')"
                        :inputValue="formatDate(listItemsPaymentSchedule[0].firstDebitateDate) || '-'"
                      />
                      <div v-else>
                        <span class="filter-item-title d-block mb-1">
                          {{ $t('mandate.date_first_debit') }}
                          <span style="color: red">*</span>
                        </span>
                        <datetime-picker-custom
                          format="YYYY-MM-DD"
                          periodFull
                          id="filter-date-end"
                          class="mr-3"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': listItemsPaymentSchedule[0].firstDebitateDate}"
                          customInputParentClass="filter-item-content"
                          customInputClass="w-100"
                          style="padding:0.35rem"
                          :maxLength="19"
                          :placeholderValue="$t('common.datepicker_format_date3')"
                          inputIcon="fa-solid fa-calendar"
                          disablePastDates
                          :showTime="false"
                          v-model="listItemsPaymentSchedule[0].firstDebitateDate"
                        />
                      </div>
                    </b-col>
                    <b-col sm="4" class="mb-5" v-if="listItemsPaymentSchedule[0].frequency === '1' || listItemsPaymentSchedule[0].frequency === 1">
                      <component
                        v-if="!editMode"
                        :is="'form-read-group-label-input'"
                        :inputLabel="$t('mandate.periodicity')"
                        :inputValue="listItemsPaymentSchedule[0].periodicity || '-'"
                      />
                      <div v-else>
                        <label>
                          {{ $t('mandate.periodicity') }} <span style="color: red">*</span>
                        </label>
                        <select class="form-control" v-model="listItemsPaymentSchedule[0].periodicity">
                          <option value="" disabled>{{ $t('mandate.periodicity_select') }}</option>
                          <option
                            v-for="p in periodicityList"
                            :key="p.value"
                            :value="p.value"
                          >
                            {{ $t(p.label) }}
                          </option>
                        </select>
                      </div>
                    </b-col>
                    <b-col sm="4" class="mb-5" v-if="listItemsPaymentSchedule[0].frequency === '1' || listItemsPaymentSchedule[0].frequency === 1">
                      <component
                        :is="editMode ? 'form-write-group-label-input' : 'form-read-group-label-input'"
                        :inputLabel="$t('mandate.nb_occurences')"
                        v-model="listItemsPaymentSchedule[0].nbOccurence"
                        :inputValue="listItemsPaymentSchedule[0].nbOccurence || '-'"
                        type="number"
                      />
                    </b-col>
                    <b-col sm="4" class="mb-5" v-if="listItemsPaymentSchedule[0].frequency === '1' || listItemsPaymentSchedule[0].frequency === 1">
                      <component
                        v-if="!editMode"
                        :is="'form-read-group-label-input'"
                        :inputLabel="$t('mandate.date_end')"
                        :inputValue="formatDate(listItemsPaymentSchedule[0].endDate) || '-'"
                      />
                      <div v-else>
                        <span class="filter-item-title d-block mb-1">
                          {{ $t('mandate.date_end') }}
                          <!-- <span style="color: red">*</span> -->
                        </span>
                        <datetime-picker-custom
                          format="YYYY-MM-DD"
                          periodFull
                          id="filter-date-end"
                          class="mr-3"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': listItemsPaymentSchedule[0].endDate}"
                          customInputParentClass="filter-item-content"
                          customInputClass="w-100"
                          style="padding:0.35rem"
                          :maxLength="19"
                          :placeholderValue="$t('common.datepicker_format_date3')"
                          inputIcon="fa-solid fa-calendar"
                          disablePastDates
                          :showTime="false"
                          v-model="listItemsPaymentSchedule[0].endDate"
                        />
                      </div>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                      <form-read-group-label-input
                        :inputLabel="$t('mandate.date_due_next')"
                        :inputValue="['0'].includes(listItemsPaymentSchedule[0].status)
                          ? '-'
                          : (formatDate(listItemsPaymentSchedule[0].nextDueDate) || '-')"
                      >
                      </form-read-group-label-input>
                    </b-col>
                    <b-col sm="4" class="mb-5">
                    </b-col>
                  </b-row>
                </form-accordion>
              </div>
              <hr v-if="listItemsPaymentScheduleDate && (listItemsPaymentSchedule[0].frequency === '0' || listItemsPaymentSchedule[0].frequency === 0)" class="mx-auto" />
              <div>
                <form-accordion
                  v-if="listItemsPaymentScheduleDate && (listItemsPaymentSchedule[0].frequency === '0' || listItemsPaymentSchedule[0].frequency === 0)"
                  :title="$t('mandate.scheduled_debit')"
                  :isTitleUpperCase="false">
                  <div v-if="editMode && (listItemsPaymentSchedule[0].frequency === '0' || listItemsPaymentSchedule[0].frequency === 0) && listItemsPaymentSchedule[0].frequency !== ''" class="ml-5 mr-5">
                    <b-button class="btn btn-tertiary mb-4" @click.prevent="addPaymentSchedule">
                      <i class="fa-solid fa-plus"></i> {{ $t('mandate.add_payment_date') }}
                    </b-button>

                    <div
                      class="rounded p-4 trackingAccordion mb-4"
                      v-for="(ps, index) in list"
                      :key="index"
                    >
                      <b-row>
                        <b-col sm="5">
                          <form-write-group-label-input
                            v-model="ps.amount"
                            :inputLabel="$t('mandate.amt') + ' (€)'"
                            inputType="number"
                            isMandatory
                            :disabled="!isEditable(ps)"
                          />
                        </b-col>

                        <b-col sm="5">
                          <div>
                            <span class="filter-item-title d-block mb-1">
                              {{ $t('mandate.payment_schedule_date') }}
                              <span style="color:red">*</span>
                            </span>
                            <datetime-picker-custom
                              format="YYYY-MM-DD"
                              periodFull
                              id="filter-datebegin"
                              class="mr-3"
                              :class="{
                                'filter-item-input': true,
                                'filter-item-input-complete': ps.paymentScheduleDate
                              }"
                              customInputParentClass="filter-item-content"
                              customInputClass="w-100"
                              style="padding:0.35rem"
                              :maxLength="19"
                              :placeholderValue="$t('common.datepicker_format_date3')"
                              inputIcon="fa-solid fa-calendar"
                              disablePastDates
                              v-model="ps.date"
                              :showTime="false"
                              :disabled="!isEditable(ps)"
                            />
                          </div>
                        </b-col>
                      </b-row>

                      <b-button
                        class="btn btn-tertiary mt-3"
                        @click.prevent="removePaymentSchedule(index)"
                        v-if="isEditable(ps)"
                      >
                        <i class="fa-solid fa-trash"></i>
                        {{ $t('mandate.delete_payment_date') }}
                      </b-button>
                    </div>
                  </div>

                  <table
                    v-else-if="!editMode && listItemsPaymentSchedule[0].frequency !== '1'"
                    class="table table-striped w-50"
                    style="margin: 0 auto"
                  >
                    <tbody>
                      <tr>
                        <th class="text-center w-25">{{ $t('mandate.amt') }}</th>
                        <th class="text-center w-25">{{ $t('mandate.date_action') }}</th>
                        <!-- <th class="text-center w-25">{{ $t('mandate.status_collection') }}</th> -->
                      </tr>
                      <tr v-for="c in listItemsPaymentScheduleDate" :key="c.date">
                        <td class="text-center w-25">
                          <div>{{ formatCurrency(c.amount) || '-' }}</div>
                        </td>
                        <td class="text-center w-25">
                          <div>{{ formatDate(c.date) || '-' }}</div>
                        </td>
                        <!-- <td class="text-center w-25">
                          <div
                            :class="['chip', 'chip--' + statusVariant(c.status)]"
                          >
                            {{ $t('mandate.status_payment_schedule_' + c.status) || '-' }}
                          </div>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </form-accordion>
              </div>
              <hr class="mx-auto" />
              <div>
                <form-accordion
                  v-if="listItemsPaymentScheduleHistory.length > 0 && !editMode"
                  :title="$t('Webheader.collections_list')"
                  :isTitleUpperCase="false">
                  <table
                    class="table table-striped w-50"
                    style="margin: 0 auto">
                    <tbody>
                      <tr>
                        <th class="text-center w-25">{{ $t('mandate.amt') }}</th>
                        <th class="text-center w-25">{{ $t('mandate.date_due') }}</th>
                        <th class="text-center w-25">{{ $t('mandate.date_debit') }}</th>
                        <th class="text-center w-25">{{ $t('mandate.status_collection') }}</th>
                      </tr>
                      <tr v-for="c in listItemsPaymentScheduleHistory" :key="c.date">
                        <td class="text-center w-25">
                          <div>{{ formatCurrency(c.Amount) || '-' }}</div>
                        </td>
                        <td class="text-center w-25">
                          <div>{{ formatDate(c.DueDate) || '-' }}</div>
                        </td>
                        <td class="text-center w-25">
                          <div>{{ formatDate(c.DebitDate) || '-' }}</div>
                        </td>
                        <td class="text-center w-25">
                          <div
                            :class="['chip', 'chip--' + statusVariant(c.Status)]"
                          >
                            {{ $t('mandate.status_collection_' + c.Status) || '-' }}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form-accordion>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="!['0'].includes(listItemsPaymentSchedule[0].status)" class="form-group justify-content-end mt-5">
            <b-col v-if="!editMode" lg="2">
              <b-button variant="primary" size="lg"
                @click="toggleEditMode">
                <i class="fa-solid fa-pen-to-square" size="17px"></i>
                <span>{{ $t('mandate.edit') }}</span>
              </b-button>
            </b-col>
            <b-col v-if="!editMode" lg="2">
              <b-button size="lg"
                variant="primary" @click="cancelPaymentSchedule">
                <i class="fa-solid fa-xmark" size="17px"></i>
                <span>{{ $t('mandate.cancel') }}</span>
              </b-button>
            </b-col>
            <!-- <b-col v-if="!editMode" lg="2">
              <b-button size="lg"
                variant="primary" @click="deletePaymentSchedule">
                <i class="fa-solid fa-trash" size="17px"></i>
                <span>{{ $t('mandate.delete') }}</span>
              </b-button>
            </b-col> -->
            <b-col v-if="editMode" lg="2" offset-lg="8">
              <b-button variant="primary" size="lg"
                @click="toggleEditMode">
                <i class="fa-solid fa-xmark" size="17px"></i>
                <span>{{ $t('mandate.cancel') }}</span>
              </b-button>
            </b-col>
            <b-col v-if="editMode" sm="2">
              <b-button
                variant="primary" @click="editPaymentSchedule"
                :disabled="!isFormValid">
                <i class="fa-solid fa-paper-plane" size="17px"></i>
                <span>{{ $t('mandate.send') }}</span>
              </b-button>
            </b-col>
          </b-row>
          <b-row v-if="listItemsPaymentSchedule[0].status === '0' && listItemsPaymentSchedule[0].StatusMandate === '5'" class="form-group justify-content-end mt-5">
            <b-col v-if="!editMode" lg="2">
              <b-button size="lg"
                variant="primary" @click="activatePaymentSchedule">
                <i class="fa-solid fa-check" size="17px"></i>
                <span>{{ $t('mandate.activate') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import FormWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import {errorMessageAlert} from "@/helpers/alert"
import { loadPage } from '@/helpers/routing'
import dateTimePicker from '@/components/common/dateTimePicker.vue'

export default {
  name: 'PaymentScheduleDetails',
  components: {
    FormReadGroupLabelInput,
    FormWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
    'datetime-picker-custom': dateTimePicker
  },
  data () {
    return {
      activateSpinner: false,
      editMode: false,
      FrequencyTypeList: [
        { value: 0, label: 'mandate.frequency_type_0' },
        { value: 1, label: 'mandate.frequency_type_1' }
      ],
      ibanList: [],
      list: [],
      listItemsPaymentSchedule: [],
      listItemsPaymentScheduleDate: [],
      listItemsPaymentScheduleHistory: [],
      periodicityList: [
        { value: 'Daily', label: 'mandate.periodicity_daily' },
        { value: 'Monthly', label: 'mandate.periodicity_monthly' },
        { value: 'Yearly', label: 'mandate.periodicity_yearly' }
      ],
    }
  },
  created () {
    this.IdPaymentSchedule = this.$route.params.id
    this.IdPaymentScheduleBulk = this.$route.query.IdPaymentScheduleBulk
    this.nextDueDate = this.$route.query.nextDueDate
    this.currentYear = this.$route.query.currentYear

    if (this.IdPaymentScheduleBulk !== undefined) {
      if (this.nextDueDate !== undefined) {
        this.returnUrl = '/payment-schedules/day/' + this.nextDueDate + "?currentYear=" + this.currentYear + "&nextDueDate=" + this.nextDueDate + '&IdPaymentScheduleBulk=' + this.IdPaymentScheduleBulk
      } else {
        this.returnUrl = '/payment-schedules/bulk/details/' + this.IdPaymentScheduleBulk + '?IdPaymentScheduleBulk=' + this.IdPaymentScheduleBulk
      }
    } else {
      if (this.nextDueDate !== undefined) {
        this.returnUrl = '/payment-schedules/day/' + this.nextDueDate + "?currentYear=" + this.currentYear + "&nextDueDate=" + this.nextDueDate
      } else {
        this.returnUrl = '/payment-schedules/unit'
      }
    }

    this.getPaymentSchedule()

    this.$f7.initPullToRefresh()
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  computed: {
    firstDebitateDate() {
      return this.listItemsPaymentSchedule[0]?.firstDebitateDate
    },
    frequencyType() {
      return this.listItemsPaymentSchedule[0]?.frequency
    },
    Amount() {
      return this.listItemsPaymentSchedule[0]?.amountR
    },
    periodicity() {
      return this.listItemsPaymentSchedule[0]?.periodicity
    },
    numberOfOccurences() {
      return this.listItemsPaymentSchedule[0]?.nbOccurence
    },
    endDate() {
      return this.listItemsPaymentSchedule[0]?.endDate
    },
    isFormValid() {
      if (this.editMode) {
        const hasIBAN = (this.listItemsPaymentSchedule[0].CdtrIBAN || '').trim().length > 0
        const hasFrequencyType = this.frequencyType !== ''

        if (this.frequencyType == 1 || this.frequencyType == '1') {
          const hasAmount = (this.Amount || '').trim().length > 0
          const hasFirstDebitateDate = (this.firstDebitateDate || '').trim().length > 0
          const hasFirstDebitateDateValid = this.isValidDate(this.firstDebitateDate)
          const hasPeriodicity = (this.periodicity || '').trim().length > 0
          const hasEndDateValid = !this.endDate || this.isValidDate(this.endDate)
          return (
            hasIBAN &&
            hasFrequencyType &&
            hasAmount &&
            hasFirstDebitateDate &&
            hasFirstDebitateDateValid &&
            hasPeriodicity &&
            hasEndDateValid
          )
        }
        if (this.frequencyType == 0 || this.frequencyType == '0') {
          if (!this.list.length) return false
          for (const item of this.list) {
            if (!item.amount) return false
            if (!item.date) return false
            if (!this.isValidDate(item.date)) return false
          }
          return hasIBAN && hasFrequencyType
        }
        return false
      }
    }
    // list() {
    //   return this.listItemsPaymentScheduleDate
    // }
  },
  watch: {
    listItemsPaymentSchedule: {
      deep: true,
      handler(newVal) {
        const item = newVal[0]
        if (item && item.CdtrIBAN) {
          item.CdtrIBAN = item.CdtrIBAN.replace(/\s+/g, '')
        }
      }
    }
  },
  methods: {
    addPaymentSchedule () {
      const newLine = { amount: '', paymentScheduleDate: '', isNew: true }
      this.list = [...this.list, newLine]

      this.amount = ''
      this.paymentScheduleDate = ''
    },
    removePaymentSchedule (index) {
      this.list.splice(index, 1)
    },
    activatePaymentSchedule () {
      let that = this
      this.$f7.modal({
        title: this.$t('mandate.element_activate_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id_payment_schedule: that.IdPaymentSchedule,
                status: 1
              }
              that.$engine.paymentSchedule.editPaymentSchedule(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('mandate.payment_schedule_enabled'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                that.editMode = false
                that.getPaymentSchedule()
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('mandate.activate_error_payment_schedule'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    cancelPaymentSchedule () {
      let that = this
      this.$f7.modal({
        title: this.$t('mandate.element_cancel_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                id_payment_schedule: that.IdPaymentSchedule,
                status: 0
              }
              that.$engine.paymentSchedule.editPaymentSchedule(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('mandate.payment_schedule_cancelled'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                that.editMode = false
                that.getPaymentSchedule()
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('mandate.cancel_error_payment_schedule'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    deletePaymentSchedule () {
      let that = this
      this.$f7.modal({
        title: this.$t('mandate.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                idSchedule: that.IdPaymentSchedule
              }
              that.$engine.paymentSchedule.deletePaymentSchedule(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('mandate.deleted_payment_schedule'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                if (that.IdPaymentScheduleBulk !== undefined) {
                  loadPage(that, {url: '/payment-schedules/bulk/details/' + that.IdPaymentScheduleBulk + '?IdPaymentScheduleBulk=' + that.IdPaymentScheduleBulk })
                } else {
                  loadPage(that, {url: '/payment-schedules/unit' })
                }
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('mandate.delete_error_payment_schedule'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editPaymentSchedule () {

      if (!this.isFormValid) return

      if (this.formHasError()) {
        return
      }

      let that = this
      const item = that.listItemsPaymentSchedule[0]
      let params = {
        id_payment_schedule: that.IdPaymentSchedule,
        debitReason: item.reason,
        frequencyType: item.frequency,
        CdtrIBAN: item.CdtrIBAN
      }
      if (item.frequency === '1' || this.frequencyType === 1) {
        params.firstDebitateDate = item.firstDebitateDate
        params.Amount = item.amountR
        params.periodicity = item.periodicity
        params.numberOfOccurences = item.nbOccurence
        params.endDate = item.endDate
      } else if (item.frequency === '0' || this.frequencyType === 0) {
        params.list = that.list.map(item => ({
          amount: item.amount,
          paymentScheduleDate: item.date
        }))
      }
      this.$engine.paymentSchedule.editPaymentSchedule(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('mandate.payment_schedule_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        this.editMode = false
        this.getPaymentSchedule()
      })
      .catch(e => {
        errorMessageAlert(e, that, that.$i18n)
        that.okMessageBox(that.$t('mandate.edit_error_payment_schedule'))
      })
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso
      // return dateIso.replace("T", " ")
    },
    formHasError () {
      // if (this.listItemsPaymentSchedule[0].CdtrIBAN === undefined || this.listItemsPaymentSchedule[0].CdtrIBAN === '') {
      //   this.okMessageBox(this.$t('mandate.missing_iban'))
      //   return true
      // }
      if (!this.isValidIban(this.listItemsPaymentSchedule[0].CdtrIBAN)) {
        this.okMessageBox(this.$t('mandate.invalid_iban'))
        return true
      }
      // if (this.frequencyType === undefined || this.frequencyType === '') {
      //   this.okMessageBox(this.$t('mandate.missing_frequency_type'))
      //   return true
      // }
      // if ((this.Amount === undefined || this.Amount === '') && (this.frequencyType === '1' || this.frequencyType === 1)) {
      //   this.okMessageBox(this.$t('mandate.missing_amt'))
      //   return true
      // }
      // if ((this.firstDebitateDate === undefined || this.firstDebitateDate === '') && (this.frequencyType === '1' || this.frequencyType === 1)) {
      //   this.okMessageBox(this.$t('mandate.missing_date_first_debit'))
      //   return true
      // }
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const minFirstDebitateDate = new Date(today)
      minFirstDebitateDate.setDate(today.getDate() + 14)

      const firstDebitDate = new Date(this.firstDebitateDate)
      firstDebitDate.setHours(0, 0, 0, 0)

      const firstDebitDateD = new Date(this.firstDebitateDateD)
      firstDebitDateD.setHours(0, 0, 0, 0)

      if (firstDebitDate.getTime() !== firstDebitDateD.getTime() && (this.frequencyType === '1' || this.frequencyType === 1)) {
        if (firstDebitDate < minFirstDebitateDate && (this.frequencyType === '1' || this.frequencyType === 1)) {
          this.okMessageBox(this.$t('mandate.first_debit_min_14_days'))
          return true
        }
      }
      if (this.frequencyType === '0' || this.frequencyType === 0) {
        // if (!this.list || this.list.length === 0) {
        //   this.okMessageBox(this.$t('mandate.add_payment_date'))
        //   return true
        // }

        for (const [index, item] of this.list.entries()) {
          // if (!item.amount || item.amount === '') {
          //   this.okMessageBox(this.$t('mandate.missing_amt', { line: index + 1 }))
          //   return true
          // }
          // if (!item.date || item.date === '') {
          //   this.okMessageBox(this.$t('mandate.missing_payment_schedule_date', { line: index + 1 }))
          //   return true
          // }
          const isEditable = this.isEditable(item)
          const isPast = new Date(item.date) < new Date()
          if (isEditable) {
            if (!(isPast)) {
              const paymentScheduleDate = new Date(item.date)
              paymentScheduleDate.setHours(0, 0, 0, 0)
              if (paymentScheduleDate < minFirstDebitateDate) {
                this.okMessageBox(this.$t('mandate.payment_schedule_date_min_14_days'))
                return true
              }
            }
          }
        }
      }
      // if ((this.periodicity === undefined || this.periodicity === '') && (this.frequencyType === '1' || this.frequencyType === 1)) {
      //   this.okMessageBox(this.$t('mandate.missing_periodicity'))
      //   return true
      // }
      // if ((this.numberOfOccurences === undefined || this.numberOfOccurences === '') && this.frequencyType === 1) {
      //   this.okMessageBox(this.$t('mandate.missing_nb_occurences'))
      //   return true
      // }
      if (
        (this.frequencyType === '1' || this.frequencyType === 1) &&
        this.endDate &&
        this.firstDebitateDate &&
        this.periodicity
      ) {
        const end = new Date(this.endDate)
        const first = new Date(this.firstDebitateDate)
        let minEndDate = new Date(first)

        if (this.periodicity === 'Daily') {
          minEndDate.setDate(first.getDate() + 1)
        } else if (this.periodicity === 'Monthly') {
          minEndDate.setMonth(first.getMonth() + 1)
        } else if (this.periodicity === 'Yearly') {
          minEndDate.setFullYear(first.getFullYear() + 1)
        }

        const endDateOnly = end.toISOString().split('T')[0]
        const minEndDateOnly = minEndDate.toISOString().split('T')[0]

        if (endDateOnly < minEndDateOnly) {
          this.okMessageBox(this.$t('mandate.end_date_after_first_debit'))
          return true
        }
      }

      return false
    },
    // getBankAccounts () {
    //   let params = {}
    //   this.$engine.paymentSchedule.getPaymentSchedule(params).then(response => {
    //     this.ibanList = response.data.BankAccount.map(acc => acc.IBAN)
    //   })
    // },
    getPaymentSchedule() {
      this.activateSpinner = true
      let that = this
      let params = {
        idSchedule: this.IdPaymentSchedule,
        IdPaymentScheduleBulk: this.IdPaymentScheduleBulk || ''
      }

      this.$engine.paymentSchedule.getPaymentSchedule(params).then((resp) => {

        let PaymentScheduleList = {}

        PaymentScheduleList = resp.data.PaymentSchedule
        PaymentScheduleList.forEach(item => {
          if (['0'].includes(String(item.status))) {
            item.nextDueDate = '-'
          }
          // else if (item.frequency === '1' || item.frequency === 1) {
          //   item.nextDueDate = this.computeNextDueDate(item)
          // }
        })
        this.firstDebitateDateD = PaymentScheduleList[0].firstDebitateDate
        this.listItemsPaymentScheduleDate = resp.data.listPaymentSchedule
        this.list = this.listItemsPaymentScheduleDate
        this.list.forEach(item => {
          item.originalDate = item.date
        })
        this.listItemsPaymentScheduleHistory = resp.data.PaymentScheduleHistory

        that.updatePaymentSchedule(PaymentScheduleList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    isEditable(ps) {
      const originalDate = ps.originalDate ? new Date(ps.originalDate) : null

      if (!originalDate) return true

      const today = new Date()
      today.setHours(0, 0, 0, 0)

      const psDate = new Date(ps.date)
      psDate.setHours(0, 0, 0, 0)

      const psOriginalDate = new Date(ps.originalDate)
      psOriginalDate.setHours(0, 0, 0, 0)

      if (psDate < today) return false

      const limit = new Date(today)
      limit.setDate(limit.getDate() + 14)

      if (psOriginalDate < limit) return false

      return true
    },
    isValidDate(date) {
      return /^\d{4}-\d{2}-\d{2}$/.test(date)
    },
    isValidIban (iban) {
      if (!iban) return false

      const clean = iban.replace(/\s+/g, '')
      return clean.length === 27
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    statusVariant(status) {
      const map = {
        1: 'warning',
        2: 'success',
        3: 'danger',
        4: 'secondary',
        5: 'info',
        6: 'danger',
        7: 'success',
        8: 'warning',
        9: 'secondary',
        10: 'info'
      }
      return map[status] || 'secondary'
    },
    toggleEditMode() {
      this.editMode = !this.editMode
      this.getPaymentSchedule()
    },
    updatePaymentSchedule(PaymentScheduleList) {
      this.listItemsPaymentSchedule = PaymentScheduleList
    },
    formatDateToYMD(date) {
      const d = new Date(date)

      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${year}-${month}-${day}`
    },
    computeNextDueDate(item) {
      const {
        firstDebitateDate,
        periodicity,
        endDate,
        nbOccurence
      } = item

      if (!firstDebitateDate || !periodicity) return '-'

      let start = new Date(firstDebitateDate)
      let today = new Date()
      today.setHours(0,0,0,0)


      if (start >= today) {
      return firstDebitateDate}

      let current = new Date(start)
      let count = 1

      while (current < today) {
        switch (periodicity.toLowerCase()) {
          case 'daily':
            current.setDate(current.getDate() + 1)
            break
          case 'monthly':
            current.setMonth(current.getMonth() + 1)
            break
          case 'yearly':
            current.setFullYear(current.getFullYear() + 1)
            break
          default:
            return '-'
        }
        count++

        if (nbOccurence && count > nbOccurence) return '-'
      }

      // Vérifier endDate
      if (endDate) {
        const end = new Date(endDate)
        if (current > end) return '-'
      }

      return this.formatDateToYMD(current)
    }
  }
}
</script>
<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
